<template>
  <div class="chat-general-wrapper">
    <ChatBody :domain="domain" type-call="GENERAL" class="flex-grow-body" ref="refChatBody" />
    <ChatDmFooter v-if="isDmVisible" @scroll-bottom="scrollToBottom" />
    <ChatFooter v-show="!isDmVisible" type-call="GENERAL" :domain="domain" :list-button-visible="footerOptions" />
  </div>
</template>

<script setup lang="ts">
import ChatBody from '@/components/domains/chat/common/ChatBody.vue';
import ChatDmFooter from '@/components/domains/chat/common/ChatDmFooter.vue';
import ChatFooter from '@/components/domains/chat/common/ChatFooter.vue';
import { useCallStore } from '@/stores/call';
import { TypeDomain } from '@/types/common';
import { ChatFooterOptions, ChatFooterViewType } from '@/types/components';
import { DEFAULT_CHAT_UI_STATE, CHAT_FOOTER_PRESETS } from '@/utils/constants/chat';
import { DOMAIN } from '@/utils/constants/common';
import { ij_bottomBarStatus, ij_chat_ui } from '@/utils/injectionKeys';

withDefaults(
  defineProps<{
    code: string;
  }>(),
  {
    code: '',
  }
);

const callStore = useCallStore();
const route = useRoute();

const refChatBody = useTemplateRef('refChatBody');

const { state } = inject(ij_chat_ui, DEFAULT_CHAT_UI_STATE); // provide: ChatLayout
const bottomBarStatus = inject(ij_bottomBarStatus, ref(0));

// DM 사용유부
const isDMEnabled = computed<boolean>(() => {
  const { options: { directMessage = false } = { directMessage: false } } = callStore.qrCodeInfo || {};
  return directMessage;
});

// DM 노출여부
const isDmVisible = computed<boolean>(() => {
  return bottomBarStatus.value === 0 && state.isVisibleDm;
});

const domain = computed<TypeDomain>(() => {
  const metaDomain = route.meta.domain;
  return metaDomain && Object.values(DOMAIN).includes(metaDomain) ? metaDomain : 'CHAT';
});

const footerViewType = computed<ChatFooterViewType>(() => {
  if (state.isVisibleMCSPController) return 'MCSP';
  if (state.isVisibleMCSController) return 'MCS';
  if (isDMEnabled.value) return 'DM';
  return 'GENERAL';
});

const footerOptions = computed<ChatFooterOptions[]>(() => {
  return CHAT_FOOTER_PRESETS[footerViewType.value] || [];
});

const scrollToBottom = () => {
  if (refChatBody.value) {
    refChatBody.value.scrollToBottom();
  }
};
</script>

<style lang="scss" scoped>
.chat-general-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.flex-grow-body {
  flex: 1;
  min-height: 0;
}
</style>
